import { CartesianGrid as RechartsCartesianGrid } from 'recharts';

export const CartesianGrid = (
    props: React.ComponentProps<typeof RechartsCartesianGrid>
) => {
    return (
        <RechartsCartesianGrid
            data-testid={'CartesianGrid-container'}
            {...props}
        />
    );
};

export default CartesianGrid;
